import CustomButton from "components/Atoms/CustomButton"
import QueryBar from "components/Common/QueryBar"
import SubHeader from "components/Organisms/SubHeader"
import React, { useCallback, useEffect } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import useFSMWalkthrough, { Walkthrough } from "../routes/walkthrough.store"
import { fsmCreateBeatWalkthroughSteps } from "../walkthrough/steps"
import BeatCalendar from "./BeatCalendar"
import SalesManList from "./SalesManList"

const BeatListPage = () => {
  const [params, setParams] = useSearchParams()

  const search = params.get("search")
  const navigate = useNavigate()

  const setState = useFSMWalkthrough(useCallback(store => store.setState, []))
  const state = useFSMWalkthrough(store => store.state)
  const completed = state?.completed
  const isCompleted = completed?.[Walkthrough.CREATE_BEAT] === "1"

  const startBeatWalkthrough = useCallback(() => {
    setState({
      run: true,
      stepIndex: 0,
      steps: fsmCreateBeatWalkthroughSteps,
      type: Walkthrough.CREATE_BEAT,
    })
  }, [setState])

  useEffect(() => {
    if (!isCompleted) {
      startBeatWalkthrough()
    }
  }, [isCompleted])
  return (
    <SubHeader
      className="flex gap-3 overflow-hidden h-content"
      showBackButton={false}
      header={
        <div className="flex justify-between items-center w-full">
          <h6>Beat Calendar View</h6>
          <QueryBar
            value={search}
            round={false}
            onChange={query => {
              params.set("search", query)
              setParams(params)
            }}
          />
          <div>
            <CustomButton
              className="mr-3"
              intent="success"
              onClick={startBeatWalkthrough}
              outlined
              icon="help"
            />
            <CustomButton
              id="fsm-add-beat"
              onClick={() => {
                setState({
                  run: false,
                  stepIndex: state.stepIndex === 0 ? 1 : state.stepIndex,
                })
                navigate("new")
                setState({ run: true })
              }}
              icon="plus"
              text={"Beat Plan"}
              intent="success"
            />
          </div>
        </div>
      }
    >
      <SalesManList />
      <BeatCalendar />
    </SubHeader>
  )
}

export default BeatListPage
